import { AiOutlineSearch } from "react-icons/ai";
import React, { useState, useEffect } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import bg_video from "../../Assets/img/Hero Section 1.mp4";
import { useNavigate } from "react-router-dom";
import { jobApi } from "../../API/Api";

const HeroSection = () => {
  const [job, setJob] = useState("");
  const [location, setLocation] = useState("");
  const [experience, setExperience] = useState("");
  const [jobs, setJobs] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();
  const [currentPage, setCurrentPage] = useState(1);
  const jobsPerPage = 3;
  const [filteredJobs, setFilteredJobs] = useState([]);
  const [meta, setMeta] = useState({});
  const [selectedJob, setSelectedJob] = useState(null);
  const fetchJobs = async () => {
    try {
      const res = await jobApi.getJobs(currentPage, jobsPerPage);
      setJobs(res.data);
      setFilteredJobs(res.data);
      setMeta(res.meta);
      if (res.data.length > 0) setSelectedJob(res.data[0]);
    } catch (err) {
      console.error("Error fetching jobs:", err);
    }
  };

  useEffect(() => {
    fetchJobs();
  }, [currentPage]);

  const handleSearch = () => {
    const query = new URLSearchParams();
    if (job) query.append("job", job);
    if (location) query.append("location", location);
    if (experience) query.append("experience", experience);

    navigate(`/candidates?${query.toString()}`);
  };

  return (
    <section className="video-hero">
      <video autoPlay muted loop playsInline className="bg-video">
        <source src={bg_video} type="video/mp4" />
        Your browser does not support the video tag.
      </video>

      <div className="video-overlay">
        <h1 className="mb-4">Global Recruitment Solutions Company</h1>

        <a
          className="btn-2 mb-lg-5 mb-4"
          href="/contact-us"
          style={{ textDecoration: "none", color: "white" }}
        >
          Inquire Now
        </a>

        <section className="w-100 md:w-75">
          <div className="container">
            <div className="search-box">
              {/* Job Position Dropdown */}
              <select
                className="form-control"
                value={job}
                onChange={(e) => setJob(e.target.value)}
              >
                <option value="">Search by Job</option>
                {[...new Set(jobs.map((j) => j.position))].map((pos) => (
                  <option key={pos} value={pos}>
                    {pos}
                  </option>
                ))}
              </select>

              {/* Location Dropdown */}
              <select
                className="form-control"
                value={location}
                onChange={(e) => setLocation(e.target.value)}
              >
                <option value="">Location</option>
                {[...new Set(jobs.flatMap((j) => j.locationsPreferred))].map(
                  (loc) => (
                    <option key={loc} value={loc}>
                      {loc}
                    </option>
                  )
                )}
              </select>

              {/* Experience Dropdown */}
              <select
                className="form-control"
                value={experience}
                onChange={(e) => setExperience(e.target.value)}
              >
                <option value="">Experience</option>
                {[...new Set(jobs.map((j) => j.experience))].map((exp) => (
                  <option key={exp} value={exp}>
                    {exp}
                  </option>
                ))}
              </select>

              <button
                className="btn btn-purple-1 text-white"
                onClick={handleSearch}
              >
                <AiOutlineSearch
                  style={{ width: "24px", height: "24px", rotate: "90deg" }}
                />
              </button>
            </div>
          </div>
        </section>
      </div>
    </section>
  );
};

export default HeroSection;
